import { _ as __rest } from '../tslib.es6-17e0406b.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { Typography } from '@mui/material';

const InformationDisplay = (_a) => {
    var { label, value } = _a, rest = __rest(_a, ["label", "value"]);
    return (jsxs("div", Object.assign({}, rest, { children: [jsx(Typography, Object.assign({ variant: "caption", color: "textSecondary" }, { children: label })), jsx(Typography, Object.assign({ variant: "subtitle2", color: "textPrimary" }, { children: value }))] })));
};

export { InformationDisplay };
